import { useState, useCallback } from 'react';
import { httpCheckoutAPI } from 'V2/Services/httpCheckoutAPI';
import { RateType, RateResponseType } from 'V2/Types/Rate';
import { transformRateResponse } from 'V2/Api/BindAPIHooks/transformers/rate.transformer';

interface UseOrderSummaryResult {
  data: RateType | null;
  isLoading: boolean;
  error: string | null;
  fetch: () => Promise<string | null>;
}

export const useOrderSummary = (appId: string): UseOrderSummaryResult => {
  const [data, setData] = useState<RateType | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async (): Promise<string | null> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await httpCheckoutAPI.post({
        url: `/bindapi/insurance_applications/${appId}/rate`,
      });
      const raw = response.data as RateResponseType;
      const transformed = transformRateResponse(raw);
      setData(transformed);
      return raw.paymentDetails?.attributes?.quoteId ?? null;
    } catch {
      setError('Unable to load order details. Please refresh and try again.');
      return null;
    } finally {
      setIsLoading(false);
    }
  }, [appId]);

  return { data, isLoading, error, fetch };
};
